<template>
  <div class="container">
    <div class="search text-center">
      <label class="checkbox-inline" v-for="(key, val) in searchConfig" track-by="$index">
        <input type="checkbox" @change="fetchList()" v-model="search" :value="key">{{val}}
      </label>
       <button class="btn  btn-info pull-right" type="button" @click="showEdit()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span>&nbsp;新增</button>
    </div>

    <table class="table-v table table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th>
          角色
          </th>
          <th>
            姓名
          </th>
          <th>
            邮箱
          </th>
          <th>
            电话
          </th>
           <th>
            添加时间
          </th>
          <th width="330">
            操作
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" track-by="$index">
          <td>
            【{{searchConfig[item.role]}}】
          </td>
          <td>
            {{item.name}}
          </td>
          <td class="text-primary">
            {{item.email}}
          </td>
          <td>
            {{item.mobile}}
          </td>
          <td>
            {{item.created_at}}
          </td>
          <td class="relative">
              <button class="btn btn-xs btn-default" type="button" @click="showEdit(item)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>&nbsp;修改</button>
          </td>
        </tr>
      </tbody>
    </table>
    <nav class="text-center">
      <ul class="pagination">
        <li v-for="item in totalPage" track-by="$index" :class="{active: $route.query.page == $index + 1}">
          <a href="javascript:void(0);" @click="page($index + 1)">{{$index+1}}</a>
        </li>
      </ul>
    </nav>
    <admin-edit :show.sync="isShowEdit" :admin.sync="selectAdmin" @callback="fetchList"></admin-edit>
  </div>
</template>

<script>
  import AdminEdit from './Edit'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import { cloneDeep } from 'lodash'

  export default {
    components: {
      AdminEdit
    },
    data () {
      return {
        search: [],
        searchConfig: {
          10: '超级管理员',
          11: 'IT',
          12: '领队',
          13: '管理员'
        },
        list: [],
        isShowEdit: false,
        isShowAdd: false,
        selectAdmin: {},
        totalPage: 1
      }
    },
    methods: {
      page (index) {
        this.$route.router.go({
          query: Object.assign({}, this.$route.query, {page: index})
        })
      },
      fetchList () {
        let params = Object.assign({
          paginate: 'yes',
          page: this.$route.query.page || 1,
          role: this.search.join(',')
        }, {
          routeId: this.$route.query.routeId
        })
        return this.$http.get(`${config.api}/adminer/account`, params)
          .then(({data}) => {
            this.$set('list', data.data)
            this.$set('totalPage', data.last_page)
          })
      },

      showEdit (admin) {
        this.selectAdmin = cloneDeep(admin)
        this.isShowEdit = true
      },
      click: utils.click
    },
    route: {
      data () {
        return this.fetchList()
      }
    }
  }
</script>

<style>
  .relative {
    position: relative;
  }
  .fadein-transition {
    display: block;
  }
  .popover-content{
    max-width:300px
  }
</style>
<style scoped>
  .search {
    margin-bottom: 20px;
  }
</style>



/** WEBPACK FOOTER **
 ** List.vue?afb7d9ca
 **/